export const COVERAGE_ALIAS = 'insurance_20_20-1-year';
export const COVERAGE_2YR_ALIAS = 'insurance_20_20-2-year';
export const UV_ALIAS = 'uv';
export const DIGITAL_BLOCK_ALIAS = 'digitalBlock';
export const HYDROPHOBIC_ALIAS = 'hydrophobic';
export const SUNGLASSES_ALIAS = 'sunglasses';
